<template>
    <div class="container training">
        <div class="row">
            <div class="col-12 col-lg-3">            
                <div class="training__thumb">
                    <img v-auth-image="'/photos/'+ training.photos[0].id + '?thumbnail=300'" alt=""  v-if="training.photos && training.photos.length > 0 && !training.main_image_id" @click="showImg(training.photos[0].id)" />

                    <img src="../../../assets/img/training_thumb.jpg" alt="" v-if="!training.main_image_id && training.photos.length==0 " />
                    <img v-auth-image="'/photos/'+ training.main_image_id" alt="" class="" v-if="training.main_image_id && training.photos.length==0" />
                    
                    <div class="training__thumb-date">
                      <h6>{{ training.start_time | formatDate('DD') }}</h6>
                      <p>{{ training.start_time | formatDate('MMMM') }}</p>
                      <p>{{ training.start_time | formatDate('YYYY') }}</p>
                    </div>
                </div>
                <p class="training__p training__category">{{ (training.event_type) ? training.event_type.name : '' }}</p>
                <h3 class="training__name" v-html="training.title"></h3>
                <p class="training__p">Adres: {{ (training.address) ? training.address.city : '' }}, {{ (training.address) ? training.address.address : '' }}</p>
                <p class="training__p training__spots">Pozostało wolnych miejsc: {{ training.max_participants_quantity - training.current_participants_quantity }}</p>
                <button class="button button--small button--filled-blue training__button" @click="enroll" :disabled="submitted" v-if="!training.amISignedUp && (formattedDate > new Date())">Zapisz się &raquo;</button>
            </div>
            <div class="col-12 col-lg-8 offset-lg-1 training__desc">
                <h1 class="training__desc-title">{{ training.title }}</h1>
                <div v-html="training.description"></div> 
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'TrainingComponent',
  data () {
    return {
        pending: true,
        training: {},
        submitted: false
    }
  },
  computed: {
    // a computed getter
    formattedDate: function () {
      return (this.training.start_time) ? this.training.start_time.toDate('yyyy-mm-dd hh:ii:ss') : new Date()
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/events/' + to.params.id
    })
    .then(response => {          
        next(vm => {
            vm.training = response.data.data.event
        })
    })
    .catch(error => next(false))
  },
  methods: {
      enroll: function() {
        var _this = this
        var event_id = this.$route.params.id
        _this.submitted = true

        Vue.axios({
            method: 'post',
            url: '/events/participate/' + event_id
        })
        .then(response => {
            this.$toaster.success(response.data.message)
            _this.submitted = false
        })
        .catch(error => {
            this.$toaster.error(error.response.data.message)
            _this.submitted = false
        })
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/training/TrainingComponent.vue